import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import { PencilIcon, UserMinusIcon } from '@heroicons/react/24/outline';
import { useAlert } from "react-alert";
import { Link } from "react-router-dom";
import "./../home/index.css";
import { postData } from "../common/utils";
import Tooltip from '../common/tooltip.js';

const ActiveUser = () => {
    const [users, setUsers] = useState([]);
    const alert = useAlert();

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + "api/user/activeuserlist")
            .then((response) => response.json())
            .then((data) => {
                if (data.issuccessful == true) {
                    setUsers(data.users);

                }
            });

    }, [])

    $(document).ready(function () {
        setTimeout(function () {
            $('#myTable').DataTable();
        }, 1000);

        $('.delete-btn').on('click', function () {
            $("#loader").css("display", "block");
            var id = $(this).data('id');

            var data = {
                UserID: id,
            };

            postData(
                process.env.REACT_APP_API_URL + "api/user/updateUserStatus",
                data
            ).then((data) => {
                if (data.issuccessful == true) {
                    $(`#status-${id}`).html('Disabled');
                    $(`#${id}`).remove();
                    $("#loader").css("display", "none");
                    alert.success(data.message);
                } else {
                    alert.error(data.message);
                }
            })
        })
    });
    return (
        <div>
            <table id="myTable" className="display table table-hover table-bordered" data-page-length='10'>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Role</th>
                        <th>Team</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => {

                        return (
                            <tr key={index} id={user.UserID}>
                                <td>{user.UserName}</td>
                                <td>{user.UserEmail}</td>
                                <td>{user.AppRole}</td>
                                <td>{user.UserTeam}</td>
                                <td className='d-flex' style={{ position: 'relative', alignItems: 'center', color: "#000", justifyContent: "space-around", padding: "12px", height: "40px", gap: "10px" }}>
                                    <Tooltip text="Edit user"><Link to={`/admin/user-management/edit-user/${btoa(user.UserID)}`} style={{ color: '#000', height: '18px' }}><PencilIcon style={{ position: 'relative', width: '18px' }} data-id={user.UserID} /></Link></Tooltip>
                                    <Tooltip text="Disable user"><UserMinusIcon style={{ position: 'relative', width: '18px' }} className='delete-btn' data-id={user.UserID} /></Tooltip>
                                </td>
                                {/* <td><button id={`delete-${user.UserID}`} className='issue-btn' data-id={user.UserID}>Delete</button></td> */}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default ActiveUser